import ReactDOM from "react-dom";
import React from "react";

export default function renderReactComponentInDocument(
    component: string,
    props: any,
    nodeId: string
): void {
    if (props) {
        ReactDOM.render(
            React.createElement(component, props),
            document.querySelector(`#${nodeId}`)
        );
    }
}
